import React from 'react'
import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    height: '5.75rem',
    borderRadius: '1rem',
    margin: '1rem 0',

    background: 'url("/placeholder.gif")',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',

    '&.even': {
      opacity: 0.4,
    },

    width: '100%',
  },
}))

export default function ExchangeCardPlaceholder({ number }: { number: number }): JSX.Element {
  const classes = useStyles({})
  return <div className={`${classes.root} ${number % 2 === 0 ? 'even' : 'odd'}`}></div>
}
